import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Trophy } from "lucide-react";

const TeamLeaderboard = () => {
  const [peers, setPeers] = useState([]);

  const defaultPeers = [
    { name: "Sarah Chen", points: 4500, avatar: "https://i.pravatar.cc/150?img=5" },
    { name: "Michael Rodriguez", points: 3000, avatar: "https://i.pravatar.cc/150?img=12" },
    { name: "Emily Watson", points: 2600, avatar: "https://i.pravatar.cc/150?img=9" },
    { name: "David Kim", points: 1500, avatar: "https://i.pravatar.cc/150?img=33" },
    { name: "Jennifer Taylor", points: 1500, avatar: "https://i.pravatar.cc/150?img=10" }
  ];

  useEffect(() => {
    // Always use default realistic peers for demo
    setPeers(defaultPeers);
  }, []);

  return (
    <Card className="bg-[#0f1419] border-gray-800/50 p-5" data-testid="team-leaderboard">
      <div className="mb-5">
        <h2 className="text-lg font-bold text-white flex items-center gap-2">
          <Trophy className="h-5 w-5 text-[#3dd9c5]" />
          Team Leaderboard
        </h2>
      </div>

      <div className="flex items-center justify-around flex-wrap gap-6">
        {peers.map((peer, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center group cursor-pointer"
            data-testid={`leaderboard-peer-${idx}`}
          >
            <Avatar className="h-14 w-14 border-2 border-[#3dd9c5]/30 group-hover:border-[#3dd9c5] transition-all mb-2">
              <AvatarImage src={peer.avatar} alt={peer.name} />
              <AvatarFallback className="bg-[#3dd9c5]/20 text-[#3dd9c5] text-sm">
                {peer.name.split(' ').map(n => n[0]).join('')}
              </AvatarFallback>
            </Avatar>
            <p className="text-xs font-semibold text-white mb-1 text-center">{peer.name}</p>
            <p className="text-xs text-[#3dd9c5] font-bold">{peer.points} pts</p>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TeamLeaderboard;
